/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DraftEmbeddedPageModalEntrypointEntrypointProps } from './DraftEmbeddedPageModalEntrypoint.entrypoint.types.tsx';

type DraftEmbeddedPageModalEntrypointComponent = EntryPointComponent<
	{},
	{},
	DraftEmbeddedPageModalEntrypointEntrypointProps,
	{}
>;

export const draftEmbeddedPageModalEntrypoint: EntryPoint<
	DraftEmbeddedPageModalEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DraftEmbeddedPageModalEntrypointComponent>(
		/* webpackChunkName: "async-draft-embedded-confluence-page-modal" */ './DraftEmbeddedPageModalDraftEmbeddedPageModal.tsx',
	),
	getPreloadProps: () => ({}),
});
